import {acFreonTypeTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = acFreonTypeTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const acFreonTypeReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default acFreonTypeReducer;
